import { render, staticRenderFns } from "./SyllabusItem.vue?vue&type=template&id=26eeebb2&scoped=true&"
import script from "./SyllabusItem.vue?vue&type=script&lang=js&"
export * from "./SyllabusItem.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusItem.vue?vue&type=style&index=0&id=26eeebb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eeebb2",
  null
  
)

export default component.exports